<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base>
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>Suche</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <b-container v-if="tree">
                        <b-row>
                            <b-col md="4" v-bind:class="[{ busy: busy }, 'opacity-transition']">
                                <pb-spinner v-if="busy"></pb-spinner>
                                <div class="tree-node">
                                    <div class="tree-children" :key="c.description" v-for="(c) in tree">
                                        <div class="node-toggler"
                                             @click.stop="c.active = !c.active">
                                            <i v-if="c.active" class="far fa-chevron-down p-0"></i>
                                            <i v-else class="far fa-chevron-right p-0"></i>
                                        </div>
                                        <div class="node-content">
                                            <div class="node-name" style="display:flex;">
                                                <div style="flex-grow: 1">{{ c.description }}</div>
                                                <img style="width: 26px; height: 26px; margin:auto;"
                                                     :src="'https://gts.pranke.com/pictures/' + c.featureId"/>
                                            </div>
                                            <branch :values="filterProperties" v-if="c.active" @add="addFilterProperty" :item="c" :key="c.oid"/>

                                        </div>

                                    </div>
                                </div>
                            </b-col>
                            <b-col class="ml-4">
                                <b-row>
                                    <b-col cols="auto" class="mb-2" :key="prop.FeatureId"
                                           v-for="(prop, idx) in filterProperties">
                                        <nobr>
                                            <div class="no-break filter-prop">
                                                <div class="d-inline" v-if="prop.Type === 'ValueList' ">
                                                    {{ prop.Description }}: {{ prop.value.Description }}
                                                </div>
                                                <div class="d-inline" v-else-if="prop.Type === 'Logical' ">
                                                    {{ prop.Description }}
                                                </div>
                                                <div class="d-inline" v-else-if="prop.Type === 'Numeric'">
                                                    {{ prop.Description }}: {{ prop.value }}
                                                </div>
                                                <div class="d-inline" v-else-if="prop.Type === 'TextShort'">
                                                    {{ prop.Description }}: {{ prop.value }}
                                                </div>
                                                <i style="cursor:pointer;line-height: initial; padding-right:0; padding-left: 10px;"
                                                   @click="remove(idx)" class="far fa-times"></i>
                                            </div>
                                        </nobr>
                                    </b-col>
                                </b-row>
<!--                                <b-pagination-->
<!--                                    v-model="currentPage"-->
<!--                                    :total-rows="totalRows"-->
<!--                                    :per-page="10"-->
<!--                                    @change="search"-->
<!--                                ></b-pagination>-->
                                <b-row >

                                    <router-link :key="article.id"
                                                 class="col-md-3 article-link mb-2 card-deck"
                                                 v-for="(article) in filterResult"
                                                 :to="{name: 'ar', params: {categoryId: article.primaryCategory, articleId: article.id, variantId: article.colorId}}">
                                        <pb-card :img-info="article.name">
                                            <template slot="image">
                                                <div v-if="article.neverOutOfStock" class="nos-img"></div>
                                                <img :src="imageResource((article.webImage || article.image), 240)"
                                                     alt="thumbnail"/>
                                            </template>
                                            <template slot="content">
                                                <span
                                                    class="d-block">{{ article.primaryDescription || article.secondaryDescription }}</span>
                                            </template>
                                        </pb-card>
                                    </router-link>
                                </b-row>
<!--                                <b-pagination-->
<!--                                    v-model="currentPage"-->
<!--                                    :total-rows="totalRows"-->
<!--                                    :per-page="10"-->
<!--                                    @change="search"-->
<!--                                ></b-pagination>-->
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>

import GtlJson from '@shared/_assets/GTL.json';
import Branch from "./Branch";
import {HTTP} from "@shared/_helpers/http";

export default {
    name: 'gtl-search',
    components: {Branch},
    data() {
        return {
            gtlJson: GtlJson,
            selectedClass: null,
            subClass: null,
            tree: null,
            filterProperties: [],
            filterResult: [],
            busy: false,
            currentPage: 1,
            totalRows: 1,
        }
    },
    mounted() {

        const classes = [];
        let valueLists = this.gtlJson.GTLCat.ValueLists;
        for(let i = 0; i < this.gtlJson.GTLCat.Segments.length; i++) {
            let seg = this.gtlJson.GTLCat.Segments[i];

            for(let z = 0; z < seg.Classes.length; z++) {
                let c = seg.Classes[z];
                if (c && c.FetureTrees && c.FetureTrees.length > 0) {
                    let featureTree = c.FetureTrees.find(t => {
                        return t.TreeViewType === 'Search';
                    });
                    const dataTree = [];
                    if(featureTree) {
                        const hashTable = Object.create(null);

                        featureTree.TreeView.forEach(aData => {
                            let dat = this.$_.cloneDeep(aData);
                            let feature = this.featureMap[dat.FeatureId];
                            if(feature && feature.ValueListId && dat.ValueId) {
                                let valueList = valueLists.find(valueList => valueList.ValueListId === feature.ValueListId);
                                let value = valueList.Values.find(v => v.ValueId === dat.ValueId);
                                feature['Value'] = value;
                            }

                            hashTable[dat.Oid] = {
                                ...dat,
                                childNodes: [],
                                active: false,
                                Feature: feature
                            }
                        });

                        featureTree.TreeView.forEach(aData => {
                            let dat = this.$_.cloneDeep(aData);
                            if (dat.ParentOid) {
                                hashTable[dat.ParentOid].childNodes.push(hashTable[dat.Oid])
                            }
                            else dataTree.push(hashTable[dat.Oid])
                        });
                    }


                    classes.push({
                        childNodes: dataTree,
                        classId: c.ClassId,
                        featureId: c.ClassId,
                        description: c.Description,
                        active: false
                    })
                }
            }
        }


        this.tree = classes;
    },
    methods: {
        search() {
            if(this.filterProperties.length > 0) {
                this.busy = true;
                HTTP.post(`/private/gtl/article/filter/${this.currentPage}/20`, this.filterProperties.map(filterProp => {
                    let val = null;

                    if(filterProp.Type == 'ValueList') {
                        val = filterProp.value.ValueId;
                    } else if(filterProp.Type == 'Logical') {
                        val = Number(filterProp.value);
                    } else {
                        val = filterProp.value;
                    }


                    return {
                        feature: filterProp.FeatureId,
                        value: val
                    }
                }))
                    .then((response) => {
                        this.filterResult = response.data.paginatedItems;
                        this.totalRows = response.data.total;
                    }).finally(() => {
                    this.busy = false;
                })
            } else {
                this.filterResult = [];
            }
        },
        remove(idx) {
            this.filterProperties.splice(idx, 1);
            this.search();
        },
        possibleValues(ValueListId) {
            return this.gtlJson.GTLCat.ValueLists.find(valueList => valueList.ValueListId === ValueListId);
        },
        addFilterProperty(property) {
            let idx = this.filterProperties.findIndex(pa => pa.FeatureId === property.FeatureId);

            if (idx !== -1) {
                let localProperty = this.filterProperties[idx];

                if (!property.value) {
                    this.filterProperties.splice(idx, 1);
                } else {
                    this.$set(this.filterProperties, idx, property);
                }


            } else {

                this.filterProperties.push(property);
            }
            this.search();
        },
    },
    computed: {
        paginatedFilterResults() {
            return this.filterResult.slice((this.currentPage - 1) * 20, this.currentPage * 20);
        },
        featureMap() {
            const hashTable = Object.create(null);
            this.gtlJson.GTLCat.Features.forEach(feature => {
                hashTable[feature.FeatureId] = feature;
            });

            return hashTable;
        },
        featureList() {
            return this.$_.orderBy(this.selectedClass.FeatureReferences.map(featureRef => {
                return this.gtlJson.GTLCat.Features.find(feature => featureRef.FeatureRef === feature.FeatureId)
            }).filter(feature => feature.Type !== 'TextShort'), ['Type'], ['asc']);
        }
    }
}
</script>

<style lang="scss">
.list-group {
    border-radius: 0;
}

.list-group > .list-group-item {
    padding-right: 0;
    border-radius: 0;
}
</style>